<app-popup-layout #modal>
  @if (fetchUsageSettings.isCompleted()) {
    <div class="container m-0 p-0">
      <div class="row m-0 p-0">
        <div class="col-sm-6 m-0 p-0">
          <img
            class="img-otp"
            [src]="
              provider === 'AU_BANK'
                ? '/assets/otp/otp-mobile.png'
                : '/assets/otp/ind-otp.png'
            "
            alt="OTP"
            />
        </div>
        <div class="col-sm-6 m-0 p-0 d-flex flex-col">
          <header class="modal-header">
            <p class="modal-title">Verify OTP</p>
            <app-close-button
              class="ms-auto"
              (onCloseEmitter)="modal.dismiss()"
            ></app-close-button>
          </header>
          <div class="modal-body form-group m-0 pt-0" [formGroup]="form">
            <p class="otp-sent-on">Enter the OTP sent on</p>
            <p class="otp-sent-mobile">{{ maskPhoneNumber(mobile) }}</p>
            <ngx-otp-input
              #ngxotp
              (fill)="patchOtpValue($event)"
              ngDefaultControl
              formControlName="otp"
              [options]="otpInputConfig"
            ></ngx-otp-input>
            <mat-error>
              <app-form-field-error
                [formControlRef]="form.get('otp')"
                [messages]="{
                  required: 'Please enter OTP',
                  pattern: '6 digit numbers are allowed'
                }"
                >
              </app-form-field-error>
            </mat-error>
            <div class="otp-resend text-end mb-5 mt-4">
              @if (!interval) {
                <a (click)="onResendOtp()">Resend OTP</a>
              }
              @if (interval) {
                <span> {{ timeLeft }} Seconds Left </span>
              }
            </div>
          </div>
          <div class="show-info">
            <img class="au-img" src="/assets/svg/star-otp.svg" alt="AU" />&nbsp;
            <p class="show-info-message ms-1">
              You will be redirected to the card portal on successful
              authentication
            </p>
          </div>
          <div class="btn-group mb-3">
            <button
              mat-flat-button
              class="outline-button me-4"
              (click)="modal.dismiss()"
              type="button"
              >
              CANCEL
            </button>
            <button
              mat-flat-button
              color="primary"
              class="ms-2 solid-btn"
              type="submit"
              [disabled]="form.invalid"
              [appLoaderButton]="formActionRequestState()"
              (click)="
                onVerify.emit({
                  submitRequestState: submitRequestState,
                  otpValue: this.form.get('otp').value
                })
              "
              >
              VERIFY
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</app-popup-layout>

@if (fetchUsageSettings.isPending()) {
  <div class="w-full pt-8">
    <app-slim-spinner class="m-auto"></app-slim-spinner>
  </div>
}
